import { render, staticRenderFns } from "./CoursePurchase.vue?vue&type=template&id=beefc1e0&scoped=true"
import script from "./CoursePurchase.vue?vue&type=script&lang=js"
export * from "./CoursePurchase.vue?vue&type=script&lang=js"
import style0 from "./CoursePurchase.vue?vue&type=style&index=0&id=beefc1e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beefc1e0",
  null
  
)

export default component.exports